import React from 'react';
import Marquee from 'react-fast-marquee';
import Aboutdata from './ClientData';
import './Clients.css';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles({
  marq: {
    display: 'flex',
    flexWrap: 'wrap',
  },
});
function Clients() {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <div
        className="clients"
        id="clients"
        style={{ paddingTop: '32px', paddingBottom: '32px' }}
      >
        {/* 
          If the image count was small then you may see white spaces at the end of the carousel, to avoid that set the maximum width accordingly in here 1500px works.
        */}
        <div
          style={{
            maxWidth: '1410px',
            width: '100%',
            padding: '0px 15px',
            margin: '0 auto',
          }}
        >
          <div className="section-title" style={{ marginBottom: '16px' }}>
            <h2>{t('sections-clients-clients-head')}</h2>
            <p>{t('sections-clients-clients-para')}</p>
          </div>
          {/* <h5 className="clientsTitle"></h5> */}
          <div className={classes.marq}>
            <Marquee speed="90" gradientWidth={0}>
              <div className="home__logo__container">
                {Aboutdata.map((client, i) => {
                  return (
                    <a
                      key={i}
                      href={client.websiteLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={client.logo} alt="" />
                    </a>
                  );
                })}
              </div>
            </Marquee>
          </div>
          <div className={classes.marq}>
            <Marquee direction="right" speed="90" gradientWidth={0}>
              <div className="home__logo__container">
                {Aboutdata.map((client, i) => {
                  return (
                    <a
                      key={i}
                      href={client.websiteLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={client.logo} alt="" />
                    </a>
                  );
                })}
              </div>
            </Marquee>
          </div>
        </div>
      </div>
    </>
  );
}

export default Clients;
